import {
  Component,
  OnChanges,
  ChangeDetectionStrategy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-code',
  templateUrl: './input-code.component.html',
  styleUrls: ['./input-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputCodeComponent implements OnChanges, OnInit {
  /** Длина кода */
  @Input() codeLength: number = 1;

  /** Флаг, что код не прошел проверку */
  @Input() codeInvalid: boolean = false;
  @Output() codeInvalidChange: EventEmitter<boolean> = new EventEmitter();

  /** Код */
  @Input() code: string = '';
  @Output() codeChange: EventEmitter<string> = new EventEmitter();

  /** Параметр для автоматической отправки кода */
  @Output() codeIsReady: EventEmitter<void> = new EventEmitter();

  protected readonly codeControl = new FormControl('');

  ngOnInit(): void {
    this.codeControl.valueChanges.subscribe(code => {
      this.setCodeInvalid(false);
      this.codeChange.emit(code ?? undefined);

      if (code?.length === this.codeLength) {
        this.codeIsReady.emit();
      }
    });

    setTimeout(() => {
      this.setFocus();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['codeInvalid'] && this.codeInvalid) {
      setTimeout(() => {
        this.codeControl.reset();
        this.setFocus();
      }, 300);
    }
  }

  private setFocus() {
    document.getElementById('inputCode')?.focus();
  }

  private setCodeInvalid(value: boolean) {
    this.codeInvalid = value;
    this.codeInvalidChange.emit(value);
  }
}
